import Dialog from "components/AppDialog/components/Dialog/Dialog";
import { ReactComponent as ErrorOutlineIcon } from "../../../../images/payment_failed.svg";
import { VStack } from "../../../Stack";
import Button from "../../../formElements/Button/Button";
import "./PaymentFailedModal.css";

interface Props {
  onClose: () => void;
}

// TODO: unite with PaymentSucceedModal
export default function PaymentFailedModal({ onClose }: Props) {
  return (
    <Dialog
      showDialog={true}
      onClose={onClose}
      closeOnOuterClick={false}
      className={"app-dialog payment-failed"}
    >
      <VStack className="container" gap={32}>
        <div className="header-rect" />
        <VStack align={"center"} gap={24} justify={"space-evenly"}>
          <ErrorOutlineIcon />
          <p className="header">Payment Failed</p>
          <p>
            Oh snap! The credit card information was declined. Please try again or contact
            support.
          </p>
          <Button className="payment-btn submit" onClick={() => onClose()}>
            Close
          </Button>
        </VStack>
      </VStack>
    </Dialog>
  );
}
